<section id="courses">
    <div class="content-wrapper">
        <div class="content-body">
            <div class="row">
                <div class="col-12">
                    <div class="container">
                        <div class="card">
                            <div class="row text-center">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h2 class="font-weight-light shadow-bottom-light p-1">Courses</h2>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row kb-search-content-info match-height mt-2">
                                    <div class="kb-search-content col-sm-6 col-md-4">
                                        <div class="card text-center cursor-pointer">
                                            <h4 class="card-title">B.Tech</h4>
                                            <!--<img src="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/img/sales.1172632b.svg"
                                                 alt="Course 1"
                                                 class="card-img-top">-->
                                            <div class="card-body">
                                                <p class="card-text mt-1"> There is perhaps no better demonstration
                                                    of
                                                    the
                                                    folly of
                                                    image of our tiny world. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="kb-search-content col-sm-6 col-md-4">
                                        <div class="card text-center cursor-pointer">
                                            <h4 class="card-title">M.Tech</h4>
                                            <div class="card-body">
                                                <p class="card-text mt-1"> Look again at that dot. That’s here.
                                                    That’s
                                                    home.
                                                    That’s
                                                    us. On it everyone you love. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="kb-search-content col-sm-6 col-md-4">
                                        <div class="card text-center cursor-pointer">
                                            <h4 class="card-title">M.Phil</h4>
                                            <div class="card-body">
                                                <p class="card-text mt-1"> every hero and coward, every creator and
                                                    destroyer of
                                                    civilization. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="kb-search-content col-sm-6 col-md-4">
                                        <div class="card text-center cursor-pointer">
                                            <h4 class="card-title">Pharmacy</h4>
                                            <div class="card-body">
                                                <p class="card-text mt-1"> It has been said that astronomy is a
                                                    humbling
                                                    and
                                                    character experience. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="kb-search-content col-sm-6 col-md-4">
                                        <div class="card text-center cursor-pointer">
                                            <h4 class="card-title">PHD</h4>
                                            <div class="card-body">
                                                <p class="card-text mt-1"> There is perhaps no better demonstration
                                                    of
                                                    the
                                                    folly of
                                                    human conceits. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="kb-search-content col-sm-6 col-md-4">
                                        <div class="card text-center cursor-pointer">
                                            <h4 class="card-title">Medical</h4>
                                            <div class="card-body">
                                                <p class="card-text mt-1"> Competent means we will never take
                                                    anything
                                                    for
                                                    granted. </p>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="text-center col-12" style="display: none;">
                                        <h4 class="mt-4"> Search result not found!! </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
